export const GOOGLE_MAP_SEARCH = 'https://www.google.com/maps/search/';
